<template>
  <div id="chat">
    <div
      class="pull-right meetbeans_sidebar messages"
      id="chatWindow2"
      v-if="messages.length > 0 && !loadingChat"
    >
      <div v-for="(m, i) in messages" :key="i" :id="'chat' + i">
        <div
          v-if="m.uid != user.uid"
          class="pull-left"
          style="margin-top: 15px"
        >
          <div class="chatting">
            <img :src="m.image" />
            <div>
              <span style="position: relative;right: 5px;bottom: 8px;">
                {{ m.account_name }}
                <span
                  id="user-info"
                  class="text-secondary"
                  style="position: absolute;left: 0px;bottom: -15px;font-size: 8.5px;width: 200px"
                  >{{ m.designation }}, {{ m.company }}</span
                >
              </span>
              <div style="margin-left: 30px;position: relative ">
                <p
                  class="message-text"
                  v-linkified:options="{ className: 'text-link' }"
                >
                  {{ m.message }}
                  <span
                    id="message-date"
                    class="text-muted"
                    style="position: absolute;right: 8px;bottom: 5px;font-size: 10px;"
                    >{{
                      $moment
                        .utc(m.created_at)
                        .local()
                        .format("LT")
                    }}</span
                  >
                </p>
                <!-- <div
                  style="margin-bottom: 10px; font-size: .7em;margin-top: -10px;border-radius: 10px"
                >
                  <button
                    style="background: #000; border: none; color: #fff;padding: .5em;border-radius: 10px"
                  >
                    <i class="fas fa-thumbs-down"></i> DOWNVOTE
                  </button>

                  <button
                    style="background: #000; border: none;  color: #fff;padding: .5em;border-radius: 10px;margin-left: 15px"
                  >
                    <i class="fas fa-thumbs-up"></i> UPVOTE
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div v-else class="float-right">
          <div id="products">
            <div class="message-blue" style="position: relative">
              <p
                class="message-content"
                v-linkified:options="{ className: 'text-link' }"
                style="border-radius: 8px"
              >
                {{ m.message }}
                <span
                  id="message-date"
                  class="text-muted"
                  style="position: absolute;right: 8px;bottom: 5px;font-size: 10px;"
                  >{{
                    $moment
                      .utc(m.created_at)
                      .local()
                      .format("LT")
                  }}</span
                >
              </p>
            </div>
            <!-- <div
                  style="margin-bottom: 10px; font-size: .7em;margin-top: 5px;border-radius: 10px; float: right"
                >
                  <button
                    style="background: #fff; border: none; color: #000;padding: .5em;border-radius: 10px"
                    @click="updateUpvote()"
                  >
                    <i class="fas fa-thumbs-down"></i> DOWNVOTE ({{ counter_upvote }})
                  </button>

                  <button
                    style="background: #fff; border: none;  color: #000;padding: .5em;border-radius: 10px;margin-left: 15px"
                    @click="updateDownvote()"
                  >
                    <i class="fas fa-thumbs-up"></i> UPVOTE ( {{ counter_downvote }})
                  </button>
                </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="messages meetbeans_sidebar text-center"
      v-else-if="messages.length === 0 && !loadingChat"
    >
      <div
        style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%)"
      >
        <svg
          width="60"
          height="60"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <image
            href="../../assets/qna.svg"
            style="color: #fbaf28 !important;"
            width="60"
            height="60"
          />
        </svg>

        <br />
        <span>
          <b>Ask your question</b>
        </span>
        <p>You will get answer of all your queries</p>
      </div>
    </div>

    <div class="sendbox">
      <div class="form-group pt-2">
        <div style="display: flex;">
          <input
            id="chatInput"
            style=""
            type="text"
            class="form-control"
            autocomplete="off"
            v-model="channelMessage"
            v-on:keyup.enter="handleChannelMessage"
            placeholder="Ask anything..."
            aria-label="channelmessage"
          />

          <button
            @click="handleChannelMessage"
            class="btn btn-primary"
            type="button"
            id="general-send-button"
            style="margin-left: -4px; border-radius: 0 5px 5px 0"
            v-if="channelMessage !== ''"
          >
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <image href="../../assets/send.svg" width="20" height="20" />
            </svg>
          </button>
          <button
            class="btn btn-primary"
            type="button"
            id="general-send-button-disable"
            style="margin-left: -4px; border-radius: 0 5px 5px 0"
            v-else
          >
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <image href="../../assets/send.svg" width="20" height="20" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SkeletonBox from "./SkeletonBox.vue";
import AgoraRTM from "agora-rtm-sdk";

export default {
  components: {
    // SkeletonBox,
  },
  data() {
    return {
      counter_upvote: 0,
      counter_downvote: 0,
      appId: "1188c95f362547c98469c3c67f487f60",
      user: {},
      client: "",
      handRaiseUserID: "",
      channel: "",
      channelId: "test",
      rtmToken: null,
      accountName: "",
      channels: {},
      isLoggedIn: false,
      channelMessage: "",
      messages: [],
      name1: [],
      name2: [],
      flagContainer: {
        isReactionAnimation: false,
      },
      channelMemberCount: Number,
      memberInterval: "",
      loadingChat: true,
      intervalId: null,
    };
  },
  beforeCreate() {},
  beforeDestroy() {
    clearInterval(this.memberInterval);
  },
  created() {
    // init AgoraRTC local client
    if (this.$route.params.session) {
      // this.accountName = this.uid
      this.user = JSON.parse(localStorage.getItem("user_info"));
      this.accountName = this.user.name;
      // this.accountName = this.uid
      if (this.user !== "undefined" || this.user !== {}) {
        this.getAgoraRTMTokenFunction();
      } else {
        this.$toast.open({
          message: "No user found, Please try login again !",
          type: "error",
          position: "top",
          queue: true,
        });
      }
    } else {
      this.$toast.open({
        message: "Sorry meeting id is required.",
        type: "success",
        position: "top",
        queue: true,
      });
    }
  },
  // beforeUpdate() {
  //   const $ = this;
  //   $.$root.$on("handleEventReaction", () => {
  //     console.log('%c:Got Reation from user--', 'background: #ff00dd; color: #00ff00', );
  //   });
  // },
  mounted() {
    this.$root.$on("scrollDown", () => {
      this.scrollDown();
    });
  },
  methods: {
    updateDownvote(){
      this.counter_downvote = this.counter_downvote + 1;  
    },
    updateUpvote(){
      this.counter_upvote = this.counter_upvote + 1;
    },
    getUserData(id) {
      // console.log(
      //   "%c:Got msg from this id-",
      //   "background: #ff00dd; color: #00ff00",
      //   id
      // );
      const $ = this;
      let da = {
        channel_id: $.$route.params.session,
      };
      $.$store.dispatch("getEventMembersData", da).then((resp) => {
        if (resp.data.status === "success") {
          $.$store.state.members = resp.data.data;
          resp.data.data.forEach((member) => {
            if (member.uid == id) {
              return member;
            }
          });
        }
      });
    },
    scrollDown: function() {
      var container = document.querySelector("#chatWindow2");
      // var chatBox = document.querySelector('.chatting');
      // console.log("HEIGHT:", chatBox.clientHeight);
      //   console.log("Container: ", container);
      //
      // console.log("ScrollHeight: ",container.scrollHeight);

      container.scrollTop = container.scrollHeight;

      // document.querySelector('.chatting').scrollIntoView(false);
    },
    getAgoraRTMTokenFunction: function() {
      const $ = this;
      // console.log("%c:uid", "background: #222; color: #00ff00", $.uid);
      if ($.uid !== null) {
        let data = {
          channel_id: this.$route.params.session,
          uid: $.user.uid,
        };
        this.$store.dispatch("getEventAgoraRTMToken", data).then((resp) => {
          if (resp.data.status === "success") {
            $.rtmToken = resp.data.data.rtm_token;
            $.uid = resp.data.data.uid + "qna";
            $.channelId = resp.data.data.channel_name + "-qna";
            this.handleClient();
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true,
            });
          }
        });
      }
    },

    handleInstance(appId) {
      this.client = AgoraRTM.createInstance(appId);
      this.subscribeClientEvents();
    },

    subscribeClientEvents() {
      const $ = this;
      // $.client.on("ConnectionStateChanged", (newState, reason) => {
      //   console.log("reason", reason, "newState: ", newState);
      //   if (newState === "ABORTED") {
      //     if (reason === "REMOTE_LOGIN") {
      //       // alert("It seems you are already active in other device. Please logout, to resume session refresh 😅.");
      //       // $.client.logout()
      //       // clearInterval($.memberInterval)
      //       // $.$root.$emit("handleLeaveTable_1", this.user.uid);
      //       // this.$router.push("/");
      //       console.log("channel name: ", $.channelId)
      //       console.log("REMOTE_LOGIN reason", reason, "newState: ", newState);
      //     }
      //   }
      // });
      // event ends here
      $.client.on("MessageFromPeer", (message, peerId) => {
        let data = {
          message: message.text,
          uid: peerId,
          account_name: peerId,
          date: new Date(),
          image: $.user.photoURL,
          company: $.user.company,
          designation: $.user.designation,
        };
        $.messages.push(data);
        $.scrollDown();
      });
      // event ends here
    },

    subscribeChannelEvents() {
      // text: text of the received channel message; senderId: user ID of the sender.
      /* Your code for handling events, such as receiving a channel message. */

      const $ = this;
      $.channel.on("ChannelMessage", (args) => {
        const text = args.text;
        $.$root.$emit("newQnaNotifier");
        if (this.$store.state.newQnaCount === 1) {
          let newMessageHeader = `<h6 style='	margin: 25px 0px 25px;font-size: 10px;font-weight: bold;width: 306px;text-align: center;border-bottom: 1px solid #fff;line-height: 0;'>
                <span style='background: #fff;color: black;padding: 5px 30px;border-radius: 3px;'>
                New Messages
                </span>
                </h6>`;
          if (document.getElementById("chatWindow2")) {
            let msgheader = document.createElement("div");
            msgheader.setAttribute("id", "qnaNewMsg");
            msgheader.innerHTML = newMessageHeader;
            document.getElementById("chatWindow2").appendChild(msgheader);
          }
        }
        $.messages.push(JSON.parse(text));
        let msg = JSON.parse(text);
        if (!document.hasFocus()) {
          console.log("focused !", !document.hasFocus());
          this.$notification.show(
            `New Message By ${msg.account_name}`,
            {
              body: `${msg.message}`,
              icon: `https://meetbeans-data.s3.ap-south-1.amazonaws.com/logo-512x512.png`,
            },
            {}
          );
        } else {
          console.log("focus else", !document.hasFocus());
        }
        $.scrollDown();
        // text: text of the received channel message; senderId: user ID of the sender.
        /* Your code for handling events, such as receiving a channel message. */
      });
      $.channel.on("MemberJoined", (args, senderId) => {
        console.log("channel ", $.channelId, " member: ", senderId, " joined");
      });
      $.channel.on("MemberLeft", (senderId) => {
        console.log("channel ", $.channelName, " member: ", senderId, " left");
        // $.$root.$emit("handleLeaveTable_1", senderId);
        // $.$root.$emit("deletethisuserfromhandrequestarray", senderId);
      });
    },

    handleChannelLeave() {
      let $ = this;
      $.channel.leave();
    },

    handleChannelJoin() {
      let $ = this;
      const newChannel = $.client.createChannel($.channelId);
      $.channel = newChannel;
      $.channels[$.channelId] = {
        newChannel,
        joined: false, // channel state
      };
      $.channel
        .join()
        .then(() => {
          /* Your code for handling the event of a join-channel success. */
          $.subscribeChannelEvents();
        })
        .catch((error) => {
          /* Your code for handling the event of a join-channel failure. */
          console.error(error);
        });
    },

    handleLogin() {
      const $ = this;
      $.handleChannelJoin();
      $.getMessageFunction();
      // $.$root.$emit("getAudience");
      $.client
        .login({ uid: $.uid, token: null })
        .then(() => {
          $.$store.state.isChatConnect = true;
          $.isLoggedIn = true;
          $.handleChannelJoin();
          $.getMessageFunction();
          // $.$root.$emit("getAudience");
        })
        .catch((err) => {
          console.error("RTM client login failure ", err);
        });
    },

    handleClient() {
      const $ = this;
      $.handleInstance($.appId);
      $.handleLogin();
    },
    storeMessageFunction(text) {
      const $ = this;
      let data = {
        channel_id: $.$route.params.session,
        text: text,
      };
      if (text !== "") {
        $.$store.dispatch("storeEventQna", data).then((resp) => {
          if (resp.data.status === "success") {
            $.scrollDown();
          }
        });
      }
    },
    getMessageFunction() {
      const $ = this;
      let data = {
        channel_id: $.$route.params.session,
      };
      $.$store.dispatch("getEventQna", data).then((resp) => {
        if (resp.data.status === "success") {
          $.loadingChat = false;
          $.messages = resp.data.data;
          if ($.messages.length > 4) {
            setTimeout(function() {
              $.scrollDown();
            }, 500);
          }
        }
      });
    },

    sendChannelMessage(res) {
      const $ = this;
      if (res.type === "chat") {
        let data = {
          message: $.channelMessage,
          uid: $.user.uid,
          account_name: $.accountName,
          image: $.user.photoURL,
          company: $.user.company,
          designation: $.user.designation,
        };
        let text = $.channelMessage;
        $.channel
          .sendMessage({ text: JSON.stringify(data) })
          .then(() => {
            $.messages.push(data);
            $.channelMessage = "";
            $.storeMessageFunction(text);
            if (document.querySelector("#qnaNewMsg")) {
              let elm = document.querySelector("#qnaNewMsg");
              elm.parentNode.removeChild(elm);
            }
            $.scrollDown();
          })
          .catch((error) => {
            /* Your code for handling events, such as a channel message-send failure. */
            console.log("Send Message", error);
          });
      }
    },
    handleChannelMessage(e) {
      const $ = this;
      if (e) {
        e.preventDefault();
      }
      if (!$.isLoggedIn) {
        // Toast.error('Please Login First')
        alert(
          "Please refresh the page in order to subscribe in the chat. Thanks 😅"
        );
        return;
      }
      if ($.channelMessage.trim() === "") {
        return;
      }
      $.sendChannelMessage({
        type: "chat",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
html {
  scroll-behavior: smooth;
}
.meetbeans_sidebar {
  box-sizing: border-box;
  height: 70vh;
  overflow-y: auto;
  width: 100%;
  /*@media only screen and (max-width: 1100px) {*/
  /*	height: 75vh;*/
  /*}*/
}
#products {
  padding: 10px;

  .message-blue {
    margin-bottom: 4px;
    padding: 10px;
    background-color: #613e00;
    width: 288px;
    height: auto;
    text-align: left;
    font: 400 0.9em "Open Sans", sans-serif;
    border-radius: 8px;

    .message-content {
      padding: 0;
      margin: 0;
      color: #fff;
    }
  }
}

.channel-padding {
  // position: relative;
  left: 731px;
  top: 250px;

  label {
    font-weight: bold;
    font-size: 25px;
    display: block;
    margin-bottom: 2px;
  }

  input {
    background: #1b1b1b !important;
    color: #fff !important;
    padding: 7px;
    margin-bottom: 11px;
    display: block;
  }
}

.meetbeans_chatBox ul .active_chat {
  border-bottom: 2px solid #fbaf28;
  padding-bottom: 5px;
  width: 45%;
  text-align: center;
}

.meetbeans_chatBox ul .active_chat a {
  color: #fbaf28;
  font-size: 25px;
}

.meetbeans_chatBox ul .deactive_chat {
  width: 45%;
  text-align: center;
}

.meetbeans_chatBox ul .deactive_chat a {
  font-size: 25px;
  color: #ccc;
}

.div_user {
  padding-bottom: 25px;
  margin-top: 25px;
}

.chatting {
  width: 270px;
}

.chatting img {
  float: left;
  max-width: 30px;
  width: 100%;
  margin-right: 10px;
  border-radius: 50%;
}

.chatting div span {
  font-size: 12px;
  color: #ccc;
  position: relative;
  right: 5px;
  bottom: -2px;
}

.chatting div p {
  background-color: #1b1b1b;
  padding: 10px;
  border-radius: 8px;
  color: #fff;
  margin-top: 6px;
  height: auto;
  font-size: 14px;
}

.chatter_herself div {
  position: relative;
  top: 52px;
  left: 17px;
  background-color: #fbaf28;
  color: #000;
  padding: 20px 0px 20px 0px;
  text-align: center;
  margin-right: 16px;
  border-radius: 10px;
  height: auto;
}
.sendbox {
  position: absolute;
  bottom: 0px;
  width: 96%;
}
</style>
